import React, { useState } from 'react';
import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const MoneyBoxPanel: React.FC = () => {
    // State for each example
    const [moneyValue, set_moneyValue] = useState(0);
    const [readOnlyMoneyValue, set_readOnlyMoneyValue] = useState(0);
    const [moneyValueDisplayChange, set_moneyValueDisplayChange] = useState(0);
    const [moneyValueWithBubble, set_moneyValueWithBubble] = useState(0);
    const [horizontalMoneyValue, set_horizontalMoneyValue] = useState(0);
    const [horizontalReadOnlyMoneyValue, set_horizontalReadOnlyMoneyValue] = useState(0);
    const [horizontalMoneyValueDisplayChange, set_horizontalMoneyValueDisplayChange] = useState(0);
    const [horizontalMoneyValueWithBubble, set_horizontalMoneyValueWithBubble] = useState(0);

    return (
        <>
            <h6 style={sectionHeaderStyle}>MoneyBox Components:</h6>
            {/* Example 3: MoneyBox */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={moneyValue}
                    onChange={set_moneyValue}
                    label='MoneyBox'
                />
            </div>

            {/* Example 4: Read Only Moneybox*/}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={readOnlyMoneyValue}
                    onChange={set_readOnlyMoneyValue}
                    label='Read-Only MoneyBox'
                    readOnly={true}
                />
            </div>
            {/* Example 5: MoneyBox - Change Display Required */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={moneyValueDisplayChange}
                    displayChange={true}
                    onChange={set_moneyValueDisplayChange}
                    label='MoneyBox (Display Decimals)'
                />
            </div>
            {/* Example 6: MoneyBox With InfoBubble */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={moneyValueWithBubble}
                    onChange={set_moneyValueWithBubble}
                    label='MoneyBox'
                    showInfoIcon={true}
                    infoText='MoneyBox with Info Bubble'
                />
            </div>

            {/* Example 7: MoneyBox (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={horizontalMoneyValue}
                    onChange={set_horizontalMoneyValue}
                    label='MoneyBox (Horiz.)'
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='250px'
                />
            </div>

            {/* Example 8: Read Only Moneybox (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={horizontalReadOnlyMoneyValue}
                    onChange={set_horizontalReadOnlyMoneyValue}
                    label='Read-Only MoneyBox (Horiz.)'
                    readOnly={true}
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='250px'
                />
            </div>
            {/* Example 9: MoneyBox - Change Display Required (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={horizontalMoneyValueDisplayChange}
                    displayChange={true}
                    onChange={set_horizontalMoneyValueDisplayChange}
                    label='MoneyBox (Display Decimals) (Horiz.)'
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='250px'
                />
            </div>
            {/* Example 10: MoneyBox With InfoBubble (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <MoneyBox
                    value={horizontalMoneyValueWithBubble}
                    onChange={set_horizontalMoneyValueWithBubble}
                    label='MoneyBox (Horiz.)'
                    showInfoIcon={true}
                    infoText='MoneyBox with Info Bubble'
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='250px'
                />
            </div>
        </>
    );
};
